module.exports = __webpack_public_path__ + "static/img/shili_zheng_bc.3b7c1ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shili_zheng_bc.png
// module id = VUJG
// module chunks = 62